import { render, staticRenderFns } from "./EMelderComponentMeldungenChatRightElement.vue?vue&type=template&id=0a7f24b0&scoped=true"
import script from "./EMelderComponentMeldungenChatRightElement.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenChatRightElement.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentMeldungenChatRightElement.vue?vue&type=style&index=0&id=0a7f24b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f24b0",
  null
  
)

export default component.exports